<div class="container">
  <span class="caption">{{ index }} {{ caption }}</span>
  <img class="image" [src]="imageUrl" alt="" />
</div>
